import type { RouteLocationNormalized } from 'vue-router'

import { keys } from '@/app/i18n'
import type { BreadcrumbItem } from '@/app/router/meta'
import { useAuthStore } from '@/app/stores/auth'
import { EMPLOYER_SOFTWARES } from '@/app/stores/session'

/**
 * The breadcrumb of another organisation's profile (`/organizations/:orgId`, legacy `common.js:55-64`): "Company
 * Profile" → the profile of the session's software (legacy read `currentSoftware` once, at load), then "Organization".
 * Set on entry (`beforeEnter`) and on every tab change (`onBeforeRouteUpdate` of the view), as settings does: the
 * location's meta is rebuilt from the record on each navigation. The array is replaced, never mutated.
 */
export function setOrganizationCrumbs(to: RouteLocationNormalized): void {
  const software = useAuthStore().currentSoftware
  const code = software && (EMPLOYER_SOFTWARES as readonly string[]).includes(software) ? software : 're'
  const crumbs: BreadcrumbItem[] = [
    { text: keys.t('company.profile.title.companyProfile'), to: `/${code}/company-profile` },
    { text: keys.t('company.profile.title.organization'), active: true },
  ]
  to.meta.breadcrumb = crumbs
}
